/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';
import { setIndex } from '../../state_old/actions/createData';

function getData(height) {
  return new Promise((resolve) => {
    get(`data/data2.json`).then((e) => {
      resolve(JSON.parse(e));
    });
  });
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

function createGeoJson(locations) {
  const geo = {
    type: 'FeatureCollection',
    features: [],
  };
  locations.forEach((obj) => {
    // console.log(obj);
    geo.features.push({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: obj.coords },
      properties: {
        id: obj.id,
        location: obj.location,
        type: obj.type,
        thumbPath: obj.thumbPath,
      },
    });
  });
  return geo;
}

function updateLocation(num, state) {
  return state.locations.find((obj) => {
    return obj.id === num;
  });
}

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    locations: [],
    geoJson: {
      type: 'FeatureCollection',
      features: [],
    },
    error: null,
    request: false,
    curIndex: -1,
    selectedLocation: {},
  },
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setIndex: (state, action) => {
      // console.log(action.payload);
      state.curIndex = action.payload;
      state.selectedLocation = updateLocation(action.payload, state);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.locations = action.payload.locations;
      state.geoJson = createGeoJson(action.payload.locations);
    });
  },
});

export default data;
